import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isEditable", "isTooltipLoaded", "onClick", "showTooltip", "size", "tooltipPlacement", "tooltipTitle", "type"];
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import styled, { css } from 'styled-components';
import { getDimensions } from '../../lib/getDimensions';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const AvatarWrapper = styled.div.withConfig({
  displayName: "AvatarContainer__AvatarWrapper",
  componentId: "h6klkp-0"
})(["box-sizing:content-box;display:inline-flex;position:relative;transition-delay:150ms;transition:margin ease 300ms;flex-shrink:0;aspect-ratio:1 / 1;border-radius:", ";", " ", ""], ({
  $type
}) => $type === 'productId' ? '3px' : '50%', ({
  $dimensions
}) => $dimensions.height === null || $dimensions.width === null ? css(["inline-size:100%;"]) : css(["inline-size:", "px;block-size:", "px;"], $dimensions.width, $dimensions.height), ({
  $cssStyles
}) => $cssStyles);
export function AvatarContainer(_ref) {
  let {
      children,
      isEditable,
      isTooltipLoaded,
      onClick,
      showTooltip,
      size,
      tooltipPlacement,
      tooltipTitle,
      type
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const cssStyles = useMapTokenPropsToCSS(Object.assign({}, rest, {
    color: 'text-core-on-fill-default'
  }));
  const dataTestIds = {
    'data-test-id': 'AvatarDisplay-switchComponent',
    'data-size': size,
    'data-type': type,
    'data-border-size': rest.borderWidth,
    'data-tooltip-loaded': showTooltip && isTooltipLoaded
  };
  const dimensions = useMemo(() => getDimensions(size), [size]);
  if (!isEditable && showTooltip && isTooltipLoaded) {
    return /*#__PURE__*/_jsx(Tooltip, {
      "data-test-id": "AvatarDisplay-tooltip",
      placement: tooltipPlacement,
      title: tooltipTitle,
      children: /*#__PURE__*/_jsx(AvatarWrapper, Object.assign({
        $cssStyles: cssStyles,
        $dimensions: dimensions,
        $type: type,
        onClick: onClick
      }, dataTestIds, {
        children: children
      }))
    });
  }
  return /*#__PURE__*/_jsx(AvatarWrapper, Object.assign({
    $cssStyles: cssStyles,
    $dimensions: dimensions,
    $type: type,
    onClick: onClick
  }, dataTestIds, {
    children: children
  }));
}